import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import { useEffect } from 'react';

// @ts-expect-error Could not find a declaration file for module 'feedback-loader/useFeedbackLoader'.
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
import { reportErrorToLogFetch } from 'academy-common-lib/utils/errorUtils';
import { getFormattedExerciseLocation } from '../../utils/ContentUtils';
const PRACTICAL_EXERCISE_SURVEY_ID_PROD = 1282;
export const navigateToExercise = (exerciseLocation, simulationPortalId) => {
  try {
    const portalId = PortalIdParser.getPortalIdFromPath();
    window.open(getFormattedExerciseLocation(exerciseLocation, simulationPortalId || portalId), '_self');
  } catch (error) {
    reportErrorToLogFetch({
      loggingTitle: 'Practical Exercise Navigate To Exercise Error',
      action: 'practical-exercise-navigate-to-exercise-error',
      error,
      additionalData: {
        exerciseLocation,
        simulationPortalId
      }
    });
  }
};
export const useLoadPracticalExerciseSurvey = ({
  skip
}) => {
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();
  useEffect(() => {
    if (skip || !enviro.isProd() || !clientLoaded) {
      return;
    }
    loadSurvey(PRACTICAL_EXERCISE_SURVEY_ID_PROD, 'CSAT');
  }, [skip, clientLoaded, loadSurvey]);
};